import apiClient from './client';

/**
 * MED-1255 — AI Frameworks Glossary API client.
 *
 * A framework glossary entry: a canonical `name` (the exact spelling the AI
 * should use) plus an optional `description` giving the AI context.
 */
export interface Framework {
  id: string;
  name: string;
  description: string | null;
  created_at: string;
  updated_at: string;
}

export interface FrameworkInput {
  name: string;
  description?: string | null;
}

/**
 * API for managing the global AI frameworks glossary (internal admin only).
 * All endpoints live under /api/admin/frameworks and are admin-gated server-side.
 */
export const frameworksApi = {
  /** List all frameworks (alphabetical). AC1. */
  getAll: async (): Promise<Framework[]> => {
    return apiClient.get<Framework[]>('/api/admin/frameworks');
  },

  /** Create a framework. AC2. */
  create: async (input: FrameworkInput): Promise<Framework> => {
    return apiClient.post<Framework>('/api/admin/frameworks', input);
  },

  /** Update a framework's name and/or description. AC3. */
  update: async (id: string, input: FrameworkInput): Promise<Framework> => {
    return apiClient.put<Framework>(`/api/admin/frameworks/${id}`, input);
  },

  /** Delete a framework. AC5. */
  delete: async (id: string): Promise<void> => {
    return apiClient.delete<void>(`/api/admin/frameworks/${id}`);
  },
};

export default frameworksApi;
